import seller from "../../../../assets/images/home/video/afesp-character.png";
import { Container, Gradient, Stream, StreamContainer } from "./styles";

export const VideoContainer = () => {
  return (
    <Gradient>
      <Container>
        <StreamContainer>
          <img src={seller} alt="Conheça o convênio AFESP." />
          <Stream>
            <iframe
              src="https://www.youtube.com/embed/xo9MPsdUBG4?si=rouEC9zhjJqWsaok"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </Stream>
        </StreamContainer>
      </Container>
    </Gradient>
  );
};
